import { render } from "./ContractProposalsPage.vue?vue&type=template&id=69be5f25&scoped=true"
import script from "./ContractProposalsPage.vue?vue&type=script&lang=js"
export * from "./ContractProposalsPage.vue?vue&type=script&lang=js"

import "./ContractProposalsPage.vue?vue&type=style&index=0&id=69be5f25&scoped=true&lang=css"

import exportComponent from "/home/runner/work/Verent_PactoAdmin_FE_UI/Verent_PactoAdmin_FE_UI/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-69be5f25"]])

export default __exports__